import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type Props = {
  count: string | number;
};

export const LinkedAudiencesCell = ({ count }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        maxWidth: 274,
        paddingTop: 0.5,
        paddingBottom: 0.5,
      }}
    >
      <Typography
        sx={{
          lineHeight: '22px',
        }}
      >
        {count}
      </Typography>
    </Box>
  );
};
